import { useEffect, useRef } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { usePermissions } from "../hooks/usePermissions";

export default function OrganizadorReminders() {
  const { canRead } = usePermissions();
  const seen = useRef(new Set());

  useEffect(() => {
    if (!canRead("organizador")) return undefined;
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get("/organizador/tareas/recordatorios");
        if (cancelled || !Array.isArray(data)) return;
        for (const t of data) {
          if (seen.current.has(t.id)) continue;
          seen.current.add(t.id);
          toast.info(`Recordatorio: ${t.titulo}`, {
            description: `${t.fecha} ${t.hora || ""}`.trim(),
            duration: 12000,
          });
          try {
            await api.post(`/organizador/tareas/${t.id}/recordatorio-visto`);
          } catch {
            /* ignore */
          }
        }
      } catch {
        /* silent */
      }
    };

    poll();
    const id = setInterval(poll, 45000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [canRead]);

  return null;
}
